import React, { useEffect } from "react";
import "./MainSection.css";
import speakerImg from "../../../assets/images/person.png";
import NathicharamiLogo from "../../../assets/images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import EventSection from "../EventSection/index";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import photoroomImg from "../../../assets/images/photoroom1.png";



const MainSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Validation Schema using Yup
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    phone: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Enter a valid phone number")
      .required("Phone Number is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    location: Yup.string().required("Location is required"),
    seats: Yup.string().required("Please select number of seats"),
    terms: Yup.boolean().oneOf([true], "You must accept Terms & Conditions"),
  });

  // Formik Hook
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      location: "",
      seats: "",
      terms: false,
    },
    validationSchema,
    onSubmit: (values) => {
      // Proceed to Razorpay Payment
      handlePayment(values);
    },
  });

  //   Razorpay Payment Integration
  // const handlePayment = (values) => {
  //   // const totalAmount = values.seats * 6000 * 100;
  //   const totalAmount = (values.seats * 5 + 5) * 100;

  //   const options = {
  //     // key: "rzp_test_IKaqULTtC8dVci",
  //     key: "rzp_live_d5gbZDoIVFB1IV",
  //     amount: totalAmount,
  //     currency: "INR",
  //     name: "Nathicharami Consultants",
  //     description: "Mobile Numerology Event",
  //     image: NathicharamiLogo,
  //     handler: function (response) {
  //       // Prepare payment details
  //       console.log(response);

  //       const paymentData = {
  //         first_name: values.firstName,
  //         last_name: values.lastName,
  //         phone_number: values.phone,
  //         email: values.email,
  //         location: values.location,
  //         no_of_sets: values.seats,
  //         razorpay_payment_id: response.razorpay_payment_id,
  //         // amount: totalAmount / 100,
  //         amount: totalAmount / 100,
  //         status: "completed",
  //       };

  //       // Send payment details using Axios
  //       axios
  //         .post(
  //           "https://campaign.naticharami.in/campaign-payment/",
  //           paymentData
  //         )
  //         .then((res) => {
  //           localStorage.setItem("paymentDetails", JSON.stringify(res.data));

  //           navigate("/payment-success");
  //         })
  //         .catch((error) => {
  //           console.error("Error sending payment details:", error);
  //           alert(
  //             "Payment recorded, but there was an issue saving your details."
  //           );
  //           navigate("/payment-failed");
  //         });
  //     },
  //     prefill: {
  //       name: `${values.firstName} ${values.lastName}`,
  //       email: values.email,
  //       contact: values.phone,
  //     },
  //     theme: {
  //       color: "#0BE93B",
  //     },
  //     modal: {
  //       ondismiss: function () {
  //         alert("Payment was canceled! Please try again.");
  //         console.log("User closed the payment modal or canceled payment.");
  //         navigate("/payment-failed");
  //       },
  //     },
  //   };

  //   const rzp = new window.Razorpay(options);
  //   rzp.open();
  // };

  const handlePayment = (values) => {
    // Step 1: Send data to campaign-data API
    const Amount = values.seats * 11000 * 100; // Amount in paise
    const AmountInRupees = Amount / 100;

    axios
      .post("https://campaign.naticharami.in/campaign-data/", {
        first_name: values.firstName,
        last_name: values.lastName,
        phone_number: values.phone,
        email: values.email,
        location: values.location,
        no_of_sets: values.seats,
        amount: AmountInRupees,
      })
      .then((res) => {
        console.log("Campaign data saved:", res.data);
        const campaign_data_id = res.data.campaign_data_id;
        const order_id = res.data.order_id;

        // Step 2: Calculate total amount
        // const totalAmount = values.seats * 5 * 100;
        // const totalAmount = values.seats * 6000 * 100;

        const seatCount = Number(values.seats) || 0;
        const totalAmount = seatCount * 11000 * 100; // Convert to paise


        console.log("Seats:", seatCount);
        console.log("Total Amount (paise):", totalAmount);
        console.log("Order ID received:", order_id);

        // Step 3: Initiate Razorpay Payment
        const options = {
          // key: "rzp_test_IKaqULTtC8dVci",

          key: "rzp_live_d5gbZDoIVFB1IV",
          amount: parseInt(totalAmount, 10),
          currency: "INR",
          name: "Nathicharami Consultants",
          description: "Mobile Numerology Event",
          image: NathicharamiLogo,
          order_id: order_id, // **Pass order_id from campaign-data API**
          handler: function (response) {
            console.log("Payment Success:", response);

            // Step 4: Send Payment details to campaign-payment API
            axios
              .post("https://campaign.naticharami.in/campaign-payment/", {
                campaign_data_id: campaign_data_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                amount_paid: totalAmount / 100,
                status: "completed",
                certificate: null,
              })
              .then((paymentRes) => {
                console.log("Payment recorded:", paymentRes.data);
                localStorage.setItem(
                  "paymentDetails",
                  JSON.stringify(paymentRes.data)
                );
                // navigate("/payment-success");
                toast.success("Payment successful! Redirecting...");
                setTimeout(() => navigate("/offline-payment-success"), 3000);
              })
              .catch((error) => {
                console.error("Error saving payment details:", error);
                // alert(
                //   "Payment recorded, but there was an issue saving your details."
                // );
                // navigate("/payment-failed");
                toast.error(
                  "Payment recorded, but there was an issue saving your details."
                );
                setTimeout(() => navigate("/offline-payment-failed"), 3000);
              });
          },
          prefill: {
            name: `${values.firstName} ${values.lastName}`,
            email: values.email,
            contact: values.phone,
          },
          theme: { color: "#0BE93B" },
          modal: {
            ondismiss: function () {
              // alert("Payment was canceled! Please try again.");
              // console.log("User closed the payment modal.");
              // navigate("/payment-failed");
              toast.warning("Payment was canceled! Please try again.");
              console.log("User closed the payment modal.");
              setTimeout(() => navigate("/offline-payment-failed"), 3000);
            },
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      })
      .catch((error) => {
        console.error("Error saving campaign data:", error);
        // alert("There was an issue saving your details. Please try again.");

        toast.warning(
          "There was an issue saving your details. Please try again."
        );
        setTimeout(() => navigate("/offline-payment-failed"), 3000);
      });
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="container">
        <div className="Maincontainer">
          <div className="web-view">
            <EventSection />
          </div>
          <div className="registerContainer">
            <div className="registerLeft">
              <div>
                📢 Seats are limited! Don’t miss this opportunity to learn from
                the best.
              </div>
              <div className="personImgContainer">
                <img src={speakerImg} alt="speaker img" />
              </div>
            </div>
            <div className="registerRight">
              <div>Register Now and secure your spot!</div>
              <form onSubmit={formik.handleSubmit}>
                <div className="register-field">
                  <label>First Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter First Name"
                      {...formik.getFieldProps("firstName")}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="error">{formik.errors.firstName}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Last Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Last Name"
                      {...formik.getFieldProps("lastName")}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="error">{formik.errors.lastName}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Phone Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Phone Number"
                      {...formik.getFieldProps("phone")}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="error">{formik.errors.phone}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Email</label>
                  <div>
                    <input
                      type="email"
                      placeholder="Enter your Email"
                      {...formik.getFieldProps("email")}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="error">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Location</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your Location"
                      {...formik.getFieldProps("location")}
                    />
                    {formik.touched.location && formik.errors.location ? (
                      <div className="error">{formik.errors.location}</div>
                    ) : null}
                  </div>
                </div>

                <div className="register-select">
                  <label>No of Seats</label>
                  <select {...formik.getFieldProps("seats")}>
                    <option value="" disabled>
                      Select Seats
                    </option>
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                  {formik.touched.seats && formik.errors.seats ? (
                    <div className="error">{formik.errors.seats}</div>
                  ) : null}
                </div>


                <div className="register-checkbox">
                  <input type="checkbox" {...formik.getFieldProps("terms")} />{" "}
                  <span>By clicking, you accept our Terms & Conditions.</span>
                  {formik.touched.terms && formik.errors.terms ? (
                    <div className="error">{formik.errors.terms}</div>
                  ) : null}
                </div>
                <div className="btnProceed">
                  <button type="submit">Proceed to Pay</button>
                </div>
              </form>
            </div>
          </div>
          <div className="mobile-view">
            <EventSection />
          </div>
          <div className="promoteContainer">
            <div className="promoteTitle">Promoted By</div>
            <div className="promoteDesc">
              Nathicharami Consultants Services Pvt Ltd
            </div>
            <div className="promoteImg">
              <img src={NathicharamiLogo} alt="nathicharami logo" />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container">
        <div className="Maincontainer mt-5">
          <div className="registerContainer">
            <div className="registerLeft">
              <div>
                Fill out the form now to join our Vastu with Aromatherapy
                webinar!
              </div>
              <div className="personImgContainer">
                <img src={photoroomImg} alt="photoroom Img" />
              </div>
            </div>
            <div className="registerRight">
              <div>
                Register now for just{" "}
                <span style={{ color: "#00B81B" }}>₹49</span>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="register-field">
                  <label>First Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter First Name"
                      {...formik.getFieldProps("firstName")}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <div className="error">{formik.errors.firstName}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Last Name</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Last Name"
                      {...formik.getFieldProps("lastName")}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <div className="error">{formik.errors.lastName}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Phone Number</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Phone Number"
                      {...formik.getFieldProps("phone")}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <div className="error">{formik.errors.phone}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Email</label>
                  <div>
                    <input
                      type="email"
                      placeholder="Enter your Email"
                      {...formik.getFieldProps("email")}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="error">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>
                <div className="register-field">
                  <label>Location</label>
                  <div>
                    <input
                      type="text"
                      placeholder="Enter your Location"
                      {...formik.getFieldProps("location")}
                    />
                    {formik.touched.location && formik.errors.location ? (
                      <div className="error">{formik.errors.location}</div>
                    ) : null}
                  </div>
                </div>

                <div className="register-select">
                  <label>No of Seats</label>
                  <select {...formik.getFieldProps("seats")}>
                    <option value="" disabled>
                      Select Seats
                    </option>
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                  {formik.touched.seats && formik.errors.seats ? (
                    <div className="error">{formik.errors.seats}</div>
                  ) : null}
                </div>

                <div className="register-checkbox">
                  <input type="checkbox" {...formik.getFieldProps("terms")} />{" "}
                  <span>By clicking, you accept our Terms & Conditions.</span>
                  {formik.touched.terms && formik.errors.terms ? (
                    <div className="error">{formik.errors.terms}</div>
                  ) : null}
                </div>
                <div className="btnProceed">
                  <button type="submit">Proceed to Pay</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default MainSection;
